import { FeildValidation } from '../modals/validation-interface';
import { RequiredValidation } from './required-validation';
export class ValidationMapper {
  public validationMap(validation: String): FeildValidation {
    let temp: FeildValidation;
    if (validation === 'required') {
      temp = new RequiredValidation();
    }
    if (validation === 'email') {
      temp = new RequiredValidation();
    }
    if (validation === 'mobile') {
      temp = new RequiredValidation();
    }
    if (validation === 'date') {
      temp = new RequiredValidation();
    }
    return temp;
  }
}
